import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

export default function FiliskaPagination(props) {
  const {
    leftRightSize,
    page,
    pages,
    onFirst,
    onLast,
    onNext,
    onPrev,
    onItemPrev,
    onItemNext,
  } = props;
  return (
    <div>
      {pages > 1 && (
        <div>
          <div style={{ display: 'inline' }}>
            <Pagination>
              <Pagination.First onClick={() => onFirst()} />
              <Pagination.Prev onClick={() => onPrev(page)} />
              {[...Array(parseInt(page) - 1).keys()].map((x) =>
                x >= page - (leftRightSize + 1) ? (
                  <Pagination.Item
                    onClick={() => onItemPrev(x + 1)}
                    key={x + 1}
                  >
                    {x + 1}
                  </Pagination.Item>
                ) : null
              )}
              <Pagination.Item active>{page}</Pagination.Item>
              {pages && pages - parseInt(page) > 0
                ? [...Array(leftRightSize).keys()].map((x) =>
                    parseInt(page) + 1 + x <= pages ? (
                      <Pagination.Item
                        key={parseInt(page) + x + 1}
                        onClick={() => onItemNext(parseInt(page) + x + 1)}
                      >
                        {parseInt(page) + x + 1}
                      </Pagination.Item>
                    ) : null
                  )
                : null}
              <Pagination.Next onClick={() => onNext(page)} />
              <Pagination.Last onClick={() => onLast()}>
                <span style={{ fontSize: '11px' }}>{pages}</span> »
              </Pagination.Last>
            </Pagination>
          </div>
        </div>
      )}
    </div>
  );
}
